import { ILocation } from '../../types/global/helper';
import type { ICampaignParticipationGate } from '../../types/global/campaignParticipationGate.types';
import type { ICampaignFeeBreakdown } from '../../types/global/campaignFeeBreakdown.types';
import type { ICampaignReferralEarningsIfFriendHired } from '../../types/global/campaignReferralEarnings.types';
import type {
    CampaignPremiumRequirement,
    ICampaignPremiumAccess,
} from '../../types/global/campaignPremiumAccess.types';

export const types = {
    JOIN_PROGRAM: 'JOIN_PROGRAM',
    JOIN_PROGRAM_SUCCESS: 'JOIN_PROGRAM_SUCCESS',
    JOIN_PROGRAM_FAIL: 'JOIN_PROGRAM_FAIL',

    CREATE_OFFSITE_CAMPAIGN: 'CREATE_OFFSITE_CAMPAIGN',
    CREATE_OFFSITE_CAMPAIGN_SUCCESS: 'CREATE_OFFSITE_CAMPAIGN_SUCCESS',
    CREATE_OFFSITE_CAMPAIGN_FAIL: 'CREATE_OFFSITE_CAMPAIGN_FAIL',
    RESET_CREATING_CAMPAIGN: 'RESET_CREATING_CAMPAIGN',

    REQUEST_TO_JOIN_CAMPAIGN: 'REQUEST_TO_JOIN_CAMPAIGN',
    REQUEST_TO_JOIN_CAMPAIGN_SUCCESS: 'REQUEST_TO_JOIN_CAMPAIGN_SUCCESS',
    REQUEST_TO_JOIN_CAMPAIGN_FAIL: 'REQUEST_TO_JOIN_CAMPAIGN_FAIL',

    APPROVE_CAMPAIGN_JOIN_REQUEST: 'APPROVE_CAMPAIGN_JOIN_REQUEST',
    APPROVE_CAMPAIGN_JOIN_REQUEST_SUCCESS: 'APPROVE_CAMPAIGN_JOIN_REQUEST_SUCCESS',
    APPROVE_CAMPAIGN_JOIN_REQUEST_FAIL: 'APPROVE_CAMPAIGN_JOIN_REQUEST_FAIL',

    BULK_APPROVE_CAMPAIGN_JOIN_REQUESTS: 'BULK_APPROVE_CAMPAIGN_JOIN_REQUESTS',
    BULK_APPROVE_CAMPAIGN_JOIN_REQUESTS_SUCCESS: 'BULK_APPROVE_CAMPAIGN_JOIN_REQUESTS_SUCCESS',
    BULK_APPROVE_CAMPAIGN_JOIN_REQUESTS_FAIL: 'BULK_APPROVE_CAMPAIGN_JOIN_REQUESTS_FAIL',

    BULK_REJECT_CAMPAIGN_JOIN_REQUESTS: 'BULK_REJECT_CAMPAIGN_JOIN_REQUESTS',
    BULK_REJECT_CAMPAIGN_JOIN_REQUESTS_SUCCESS: 'BULK_REJECT_CAMPAIGN_JOIN_REQUESTS_SUCCESS',
    BULK_REJECT_CAMPAIGN_JOIN_REQUESTS_FAIL: 'BULK_REJECT_CAMPAIGN_JOIN_REQUESTS_FAIL',

    BULK_RESCIND_CAMPAIGN_PARTICIPANTS: 'BULK_RESCIND_CAMPAIGN_PARTICIPANTS',
    BULK_RESCIND_CAMPAIGN_PARTICIPANTS_SUCCESS: 'BULK_RESCIND_CAMPAIGN_PARTICIPANTS_SUCCESS',
    BULK_RESCIND_CAMPAIGN_PARTICIPANTS_FAIL: 'BULK_RESCIND_CAMPAIGN_PARTICIPANTS_FAIL',

    REJECT_CAMPAIGN_JOIN_REQUEST: 'REJECT_CAMPAIGN_JOIN_REQUEST',
    REJECT_CAMPAIGN_JOIN_REQUEST_SUCCESS: 'REJECT_CAMPAIGN_JOIN_REQUEST_SUCCESS',
    REJECT_CAMPAIGN_JOIN_REQUEST_FAIL: 'REJECT_CAMPAIGN_JOIN_REQUEST_FAIL',

    GET_CAMPAIGN_PENDING_INVITES: 'GET_CAMPAIGN_PENDING_INVITES',
    GET_CAMPAIGN_PENDING_INVITES_SUCCESS: 'GET_CAMPAIGN_PENDING_INVITES_SUCCESS',
    GET_CAMPAIGN_PENDING_INVITES_FAIL: 'GET_CAMPAIGN_PENDING_INVITES_FAIL',

    CANCEL_CAMPAIGN_INVITE: 'CANCEL_CAMPAIGN_INVITE',
    CANCEL_CAMPAIGN_INVITE_SUCCESS: 'CANCEL_CAMPAIGN_INVITE_SUCCESS',
    CANCEL_CAMPAIGN_INVITE_FAIL: 'CANCEL_CAMPAIGN_INVITE_FAIL',

    RESCIND_CAMPAIGN_PARTICIPANT_APPROVAL: 'RESCIND_CAMPAIGN_PARTICIPANT_APPROVAL',
    RESCIND_CAMPAIGN_PARTICIPANT_APPROVAL_SUCCESS: 'RESCIND_CAMPAIGN_PARTICIPANT_APPROVAL_SUCCESS',
    RESCIND_CAMPAIGN_PARTICIPANT_APPROVAL_FAIL: 'RESCIND_CAMPAIGN_PARTICIPANT_APPROVAL_FAIL',

    GET_OFFSITE_CAMPAIGN_DETAILS: 'GET_OFFSITE_CAMPAIGN_DETAILS',
    GET_OFFSITE_CAMPAIGN_DETAILS_SUCCESS: 'GET_OFFSITE_CAMPAIGN_DETAILS_SUCCESS',
    GET_OFFSITE_CAMPAIGN_DETAILS_FAIL: 'GET_OFFSITE_CAMPAIGN_DETAILS_FAIL',

    UPDATE_OFFSITE_CAMPAIGN: 'UPDATE_OFFSITE_CAMPAIGN',
    UPDATE_OFFSITE_CAMPAIGN_SUCCESS: 'UPDATE_OFFSITE_CAMPAIGN_SUCCESS',
    UPDATE_OFFSITE_CAMPAIGN_FAIL: 'UPDATE_OFFSITE_CAMPAIGN_FAIL',

    UPDATE_CAMPAIGN_STATUS: 'UPDATE_CAMPAIGN_STATUS',
    UPDATE_CAMPAIGN_STATUS_SUCCESS: 'UPDATE_CAMPAIGN_STATUS_SUCCESS',
    UPDATE_CAMPAIGN_STATUS_FAIL: 'UPDATE_CAMPAIGN_STATUS_FAIL',

    DELETE_OFFSITE_CAMPAIGN: 'DELETE_OFFSITE_CAMPAIGN',
    DELETE_OFFSITE_CAMPAIGN_SUCCESS: 'DELETE_OFFSITE_CAMPAIGN_SUCCESS',
    DELETE_OFFSITE_CAMPAIGN_FAIL: 'DELETE_OFFSITE_CAMPAIGN_FAIL',

    REQUEST_DELIEVERABLE_UPDATE: 'REQUEST_DELIEVERABLE_UPDATE',
    REQUEST_DELIEVERABLE_UPDATE_SUCCESS: 'REQUEST_DELIEVERABLE_UPDATE_SUCCESS',
    REQUEST_DELIEVERABLE_UPDATE_FAIL: 'REQUEST_DELIEVERABLE_UPDATE_FAIL',

    BULK_REQUEST_REVISION: 'BULK_REQUEST_REVISION',
    BULK_REQUEST_REVISION_SUCCESS: 'BULK_REQUEST_REVISION_SUCCESS',
    BULK_REQUEST_REVISION_FAIL: 'BULK_REQUEST_REVISION_FAIL',

    RELAUNCH_CAMPAIGN: 'RELAUNCH_CAMPAIGN',
    RELAUNCH_CAMPAIGN_SUCCESS: 'RELAUNCH_CAMPAIGN_SUCCESS',
    RELAUNCH_CAMPAIGN_FAIL: 'RELAUNCH_CAMPAIGN_FAIL',

    SEND_CAMPAIGN_MESSAGE: 'SEND_CAMPAIGN_MESSAGE',
    SEND_CAMPAIGN_MESSAGE_SUCCESS: 'SEND_CAMPAIGN_MESSAGE_SUCCESS',
    SEND_CAMPAIGN_MESSAGE_FAIL: 'SEND_CAMPAIGN_MESSAGE_FAIL',

    DELETE_CAMPAIGN_MESSAGE: 'DELETE_CAMPAIGN_MESSAGE',
    DELETE_CAMPAIGN_MESSAGE_SUCCESS: 'DELETE_CAMPAIGN_MESSAGE_SUCCESS',
    DELETE_CAMPAIGN_MESSAGE_FAIL: 'DELETE_CAMPAIGN_MESSAGE_FAIL',

    UPDATE_CAMPAIGN_MESSAGE: 'UPDATE_CAMPAIGN_MESSAGE',
    UPDATE_CAMPAIGN_MESSAGE_SUCCESS: 'UPDATE_CAMPAIGN_MESSAGE_SUCCESS',
    UPDATE_CAMPAIGN_MESSAGE_FAIL: 'UPDATE_CAMPAIGN_MESSAGE_FAIL',

    APPROVE_DELIVERABLE_SUBMISSION: 'APPROVE_DELIVERABLE_SUBMISSION',
    APPROVE_DELIVERABLE_SUBMISSION_SUCCESS: 'APPROVE_DELIVERABLE_SUBMISSION_SUCCESS',
    APPROVE_DELIVERABLE_SUBMISSION_FAIL: 'APPROVE_DELIVERABLE_SUBMISSION_FAIL',

    SCHEDULE_POST: 'SCHEDULE_POST',
    SCHEDULE_POST_SUCCESS: 'SCHEDULE_POST_SUCCESS',
    SCHEDULE_POST_FAIL: 'SCHEDULE_POST_FAIL',

    UPLOAD_DELIVERABLE: 'UPLOAD_DELIVERABLE',
    UPLOAD_DELIVERABLE_SUCCESS: 'UPLOAD_DELIVERABLE_SUCCESS',
    UPLOAD_DELIVERABLE_FAIL: 'UPLOAD_DELIVERABLE_FAIL',

    GET_CAMPAIGN_JOB_DETAILS: 'GET_CAMPAIGN_JOB_DETAILS',
    GET_CAMPAIGN_JOB_DETAILS_SUCCESS: 'GET_CAMPAIGN_JOB_DETAILS_SUCCESS',
    GET_CAMPAIGN_JOB_DETAILS_FAIL: 'GET_CAMPAIGN_JOB_DETAILS_FAIL',

    GET_CAMPAIGN_APPLICATION_REVIEW: 'GET_CAMPAIGN_APPLICATION_REVIEW',
    GET_CAMPAIGN_APPLICATION_REVIEW_SUCCESS: 'GET_CAMPAIGN_APPLICATION_REVIEW_SUCCESS',
    GET_CAMPAIGN_APPLICATION_REVIEW_FAIL: 'GET_CAMPAIGN_APPLICATION_REVIEW_FAIL',
    CLEAR_CAMPAIGN_APPLICATION_REVIEW: 'CLEAR_CAMPAIGN_APPLICATION_REVIEW',

    GET_CAMPAIGN_WORKSPACE: 'GET_CAMPAIGN_WORKSPACE',
    GET_CAMPAIGN_WORKSPACE_SUCCESS: 'GET_CAMPAIGN_WORKSPACE_SUCCESS',
    GET_CAMPAIGN_WORKSPACE_FAIL: 'GET_CAMPAIGN_WORKSPACE_FAIL',
    CLEAR_CAMPAIGN_WORKSPACE: 'CLEAR_CAMPAIGN_WORKSPACE',
    WORKSPACE_SUBMISSION_REVISION_RECEIVED: 'WORKSPACE_SUBMISSION_REVISION_RECEIVED',

    SEND_CAMPAIGN_THREAD_MESSAGE: 'SEND_CAMPAIGN_THREAD_MESSAGE',
    SEND_CAMPAIGN_THREAD_MESSAGE_SUCCESS: 'SEND_CAMPAIGN_THREAD_MESSAGE_SUCCESS',
    SEND_CAMPAIGN_THREAD_MESSAGE_FAIL: 'SEND_CAMPAIGN_THREAD_MESSAGE_FAIL',

    BROADCAST_CAMPAIGN_PARTICIPANT_MESSAGE: 'BROADCAST_CAMPAIGN_PARTICIPANT_MESSAGE',
    BROADCAST_CAMPAIGN_PARTICIPANT_MESSAGE_SUCCESS: 'BROADCAST_CAMPAIGN_PARTICIPANT_MESSAGE_SUCCESS',
    BROADCAST_CAMPAIGN_PARTICIPANT_MESSAGE_FAIL: 'BROADCAST_CAMPAIGN_PARTICIPANT_MESSAGE_FAIL',

    LIST_CAMPAIGN_THREAD_MESSAGES: 'LIST_CAMPAIGN_THREAD_MESSAGES',
    LIST_CAMPAIGN_THREAD_MESSAGES_SUCCESS: 'LIST_CAMPAIGN_THREAD_MESSAGES_SUCCESS',
    LIST_CAMPAIGN_THREAD_MESSAGES_FAIL: 'LIST_CAMPAIGN_THREAD_MESSAGES_FAIL',

    PATCH_CAMPAIGN_THREAD_MESSAGE: 'PATCH_CAMPAIGN_THREAD_MESSAGE',
    PATCH_CAMPAIGN_THREAD_MESSAGE_SUCCESS: 'PATCH_CAMPAIGN_THREAD_MESSAGE_SUCCESS',
    PATCH_CAMPAIGN_THREAD_MESSAGE_FAIL: 'PATCH_CAMPAIGN_THREAD_MESSAGE_FAIL',

    DELETE_CAMPAIGN_THREAD_MESSAGE: 'DELETE_CAMPAIGN_THREAD_MESSAGE',
    DELETE_CAMPAIGN_THREAD_MESSAGE_SUCCESS: 'DELETE_CAMPAIGN_THREAD_MESSAGE_SUCCESS',
    DELETE_CAMPAIGN_THREAD_MESSAGE_FAIL: 'DELETE_CAMPAIGN_THREAD_MESSAGE_FAIL',

    MARK_CAMPAIGN_THREAD_READ: 'MARK_CAMPAIGN_THREAD_READ',
    MARK_CAMPAIGN_THREAD_READ_SUCCESS: 'MARK_CAMPAIGN_THREAD_READ_SUCCESS',
    MARK_CAMPAIGN_THREAD_READ_FAIL: 'MARK_CAMPAIGN_THREAD_READ_FAIL',

    MARK_ALL_CAMPAIGN_THREADS_READ: 'MARK_ALL_CAMPAIGN_THREADS_READ',
    MARK_ALL_CAMPAIGN_THREADS_READ_SUCCESS: 'MARK_ALL_CAMPAIGN_THREADS_READ_SUCCESS',
    MARK_ALL_CAMPAIGN_THREADS_READ_FAIL: 'MARK_ALL_CAMPAIGN_THREADS_READ_FAIL',

    CAMPAIGN_THREAD_SOCKET_JOIN: 'CAMPAIGN_THREAD_SOCKET_JOIN',
    CAMPAIGN_THREAD_SOCKET_LEAVE: 'CAMPAIGN_THREAD_SOCKET_LEAVE',
    CAMPAIGN_THREAD_SOCKET_TYPING: 'CAMPAIGN_THREAD_SOCKET_TYPING',
    CAMPAIGN_THREAD_MESSAGE_NEW: 'CAMPAIGN_THREAD_MESSAGE_NEW',
    CAMPAIGN_THREAD_MESSAGE_UPDATED: 'CAMPAIGN_THREAD_MESSAGE_UPDATED',
    CAMPAIGN_THREAD_MESSAGE_DELETED: 'CAMPAIGN_THREAD_MESSAGE_DELETED',
    CAMPAIGN_THREAD_ATTACHMENT_PROCESSING: 'CAMPAIGN_THREAD_ATTACHMENT_PROCESSING',
    CAMPAIGN_THREAD_UNREAD_UPDATED: 'CAMPAIGN_THREAD_UNREAD_UPDATED',
    CAMPAIGN_THREAD_SOCKET_ERROR: 'CAMPAIGN_THREAD_SOCKET_ERROR',
    CAMPAIGN_THREAD_TYPING_RECEIVED: 'CAMPAIGN_THREAD_TYPING_RECEIVED',
    CAMPAIGN_THREAD_TYPING_CLEARED: 'CAMPAIGN_THREAD_TYPING_CLEARED',

    SUBMIT_PARTICIPANT_WORK: 'SUBMIT_PARTICIPANT_WORK',
    SUBMIT_PARTICIPANT_WORK_SUCCESS: 'SUBMIT_PARTICIPANT_WORK_SUCCESS',
    SUBMIT_PARTICIPANT_WORK_FAIL: 'SUBMIT_PARTICIPANT_WORK_FAIL',
    SET_PARTICIPANT_UPLOAD_PROGRESS: 'SET_PARTICIPANT_UPLOAD_PROGRESS',

    SUBMIT_LIVE_URL: 'SUBMIT_LIVE_URL',
    SUBMIT_LIVE_URL_SUCCESS: 'SUBMIT_LIVE_URL_SUCCESS',
    SUBMIT_LIVE_URL_FAIL: 'SUBMIT_LIVE_URL_FAIL',

    RETRY_SUBMISSION_PROCESSING: 'RETRY_SUBMISSION_PROCESSING',
    RETRY_SUBMISSION_PROCESSING_SUCCESS: 'RETRY_SUBMISSION_PROCESSING_SUCCESS',
    RETRY_SUBMISSION_PROCESSING_FAIL: 'RETRY_SUBMISSION_PROCESSING_FAIL',

    MARK_SHARED: 'MARK_SHARED',
    MARK_SHARED_SUCCESS: 'MARK_SHARED_SUCCESS',
    MARK_SHARED_FAIL: 'MARK_SHARED_FAIL',

    REQUEST_LIVE_URL_REVISION: 'REQUEST_LIVE_URL_REVISION',
    REQUEST_LIVE_URL_REVISION_SUCCESS: 'REQUEST_LIVE_URL_REVISION_SUCCESS',
    REQUEST_LIVE_URL_REVISION_FAIL: 'REQUEST_LIVE_URL_REVISION_FAIL',

    WITHDRAW_FROM_CAMPAIGN: 'WITHDRAW_FROM_CAMPAIGN',
    WITHDRAW_FROM_CAMPAIGN_SUCCESS: 'WITHDRAW_FROM_CAMPAIGN_SUCCESS',
    WITHDRAW_FROM_CAMPAIGN_FAIL: 'WITHDRAW_FROM_CAMPAIGN_FAIL',

    WORKSPACE_SUBMISSION_APPROVED_RECEIVED: 'WORKSPACE_SUBMISSION_APPROVED_RECEIVED',
    WORKSPACE_LIVE_URL_REVISION_RECEIVED: 'WORKSPACE_LIVE_URL_REVISION_RECEIVED',

    SAVE_BRAND_REVIEW: 'SAVE_BRAND_REVIEW',
    SAVE_BRAND_REVIEW_SUCCESS: 'SAVE_BRAND_REVIEW_SUCCESS',
    SAVE_BRAND_REVIEW_FAIL: 'SAVE_BRAND_REVIEW_FAIL',

    FETCH_BRAND_REVIEWS_PAGE: 'FETCH_BRAND_REVIEWS_PAGE',
    FETCH_BRAND_REVIEWS_PAGE_SUCCESS: 'FETCH_BRAND_REVIEWS_PAGE_SUCCESS',
    FETCH_BRAND_REVIEWS_PAGE_FAIL: 'FETCH_BRAND_REVIEWS_PAGE_FAIL',

    SAVE_INFLUENCER_REVIEW: 'SAVE_INFLUENCER_REVIEW',
    SAVE_INFLUENCER_REVIEW_SUCCESS: 'SAVE_INFLUENCER_REVIEW_SUCCESS',
    SAVE_INFLUENCER_REVIEW_FAIL: 'SAVE_INFLUENCER_REVIEW_FAIL',

    MANAGE_OFFSITE_CAMPAIGNS: 'MANAGE_OFFSITE_CAMPAIGNS',
    MANAGE_OFFSITE_CAMPAIGNS_SUCCESS: 'MANAGE_OFFSITE_CAMPAIGNS_SUCCESS',
    MANAGE_OFFSITE_CAMPAIGNS_FAIL: 'MANAGE_OFFSITE_CAMPAIGNS_FAIL',

    GET_BRANDS: 'GET_BRANDS',
    GET_BRANDS_SUCCESS: 'GET_BRANDS_SUCCESS',
    GET_BRANDS_FAIL: 'GET_BRANDS_FAIL',

    GET_BRAND: 'GET_BRAND',
    GET_BRAND_SUCCESS: 'GET_BRAND_SUCCESS',
    GET_BRAND_FAIL: 'GET_BRAND_FAIL',

    ADD_BRAND: 'ADD_BRAND',
    ADD_BRAND_SUCCESS: 'ADD_BRAND_SUCCESS',
    ADD_BRAND_FAIL: 'ADD_BRAND_FAIL',

    UPDATE_BRAND: 'UPDATE_BRAND',
    UPDATE_BRAND_SUCCESS: 'UPDATE_BRAND_SUCCESS',
    UPDATE_BRAND_FAIL: 'UPDATE_BRAND_FAIL',

    DELETE_BRAND: 'DELETE_BRAND',
    DELETE_BRAND_SUCCESS: 'DELETE_BRAND_SUCCESS',
    DELETE_BRAND_FAIL: 'DELETE_BRAND_FAIL',

    /** Brand dashboard: which brand is selected in the UI (header, campaigns, etc.) */
    SET_BRAND_DASHBOARD_ACTIVE_BRAND: 'SET_BRAND_DASHBOARD_ACTIVE_BRAND',

    GET_BUZZBRIDGE_PROFILE: 'GET_BUZZBRIDGE_PROFILE',
    GET_BUZZBRIDGE_PROFILE_SUCCESS: 'GET_BUZZBRIDGE_PROFILE_SUCCESS',
    GET_BUZZBRIDGE_PROFILE_FAIL: 'GET_BUZZBRIDGE_PROFILE_FAIL',
    /** GET /influencers/me/profile returned 404 — signed-in user has no creator profile yet */
    GET_BUZZBRIDGE_PROFILE_NO_INFLUENCER: 'GET_BUZZBRIDGE_PROFILE_NO_INFLUENCER',

    /** GET /influencers/public/:userName — public card; Bearer sent when logged in */
    GET_PUBLIC_INFLUENCER_PROFILE: 'GET_PUBLIC_INFLUENCER_PROFILE',
    GET_PUBLIC_INFLUENCER_PROFILE_SUCCESS: 'GET_PUBLIC_INFLUENCER_PROFILE_SUCCESS',
    GET_PUBLIC_INFLUENCER_PROFILE_FAIL: 'GET_PUBLIC_INFLUENCER_PROFILE_FAIL',

    UPDATE_BUZZBRIDGE_PROFILE: 'UPDATE_BUZZBRIDGE_PROFILE',
    UPDATE_BUZZBRIDGE_PROFILE_SUCCESS: 'UPDATE_BUZZBRIDGE_PROFILE_SUCCESS',
    UPDATE_BUZZBRIDGE_PROFILE_FAIL: 'UPDATE_BUZZBRIDGE_PROFILE_FAIL',

    SAVE_MANUAL_INSTAGRAM_LINK: 'SAVE_MANUAL_INSTAGRAM_LINK',
    SAVE_MANUAL_INSTAGRAM_LINK_SUCCESS: 'SAVE_MANUAL_INSTAGRAM_LINK_SUCCESS',
    SAVE_MANUAL_INSTAGRAM_LINK_FAIL: 'SAVE_MANUAL_INSTAGRAM_LINK_FAIL',

    SEARCH_BRANDS: 'SEARCH_BRANDS',
    SEARCH_BRANDS_SUCCESS: 'SEARCH_BRANDS_SUCCESS',
    SEARCH_BRANDS_FAIL: 'SEARCH_BRANDS_FAIL',

    GET_HOST_DASHBOARD: 'GET_HOST_DASHBOARD',
    GET_HOST_DASHBOARD_SUCCESS: 'GET_HOST_DASHBOARD_SUCCESS',
    GET_HOST_DASHBOARD_FAIL: 'GET_HOST_DASHBOARD_FAIL',

    BRAND_SOCIAL_LOGIN: 'BRAND_SOCIAL_LOGIN',
    BRAND_SOCIAL_LOGIN_SUCCESS: 'BRAND_SOCIAL_LOGIN_SUCCESS',
    BRAND_SOCIAL_LOGIN_FAIL: 'BRAND_SOCIAL_LOGIN_FAIL',

    CREATE_BRAND_SOCIAL_LINK: 'CREATE_BRAND_SOCIAL_LINK',
    UPDATE_BRAND_SOCIAL_LINK: 'UPDATE_BRAND_SOCIAL_LINK',

    // Campaign Wallet
    GET_WALLET_DASHBOARD: 'GET_WALLET_DASHBOARD',
    GET_WALLET_DASHBOARD_SUCCESS: 'GET_WALLET_DASHBOARD_SUCCESS',
    GET_WALLET_DASHBOARD_FAIL: 'GET_WALLET_DASHBOARD_FAIL',

    /** Influencer commission wallet (GET /commission/wallet) */
    GET_COMMISSION_WALLET: 'GET_COMMISSION_WALLET',
    GET_COMMISSION_WALLET_SUCCESS: 'GET_COMMISSION_WALLET_SUCCESS',
    GET_COMMISSION_WALLET_FAIL: 'GET_COMMISSION_WALLET_FAIL',

    CASH_OUT_COMMISSION_WALLET: 'CASH_OUT_COMMISSION_WALLET',
    CASH_OUT_COMMISSION_WALLET_SUCCESS: 'CASH_OUT_COMMISSION_WALLET_SUCCESS',
    CASH_OUT_COMMISSION_WALLET_FAIL: 'CASH_OUT_COMMISSION_WALLET_FAIL',

    FUND_WALLET: 'FUND_WALLET',
    FUND_WALLET_SUCCESS: 'FUND_WALLET_SUCCESS',
    FUND_WALLET_FAIL: 'FUND_WALLET_FAIL',

    LOCK_ESCROW: 'LOCK_ESCROW',
    LOCK_ESCROW_SUCCESS: 'LOCK_ESCROW_SUCCESS',
    LOCK_ESCROW_FAIL: 'LOCK_ESCROW_FAIL',

    RELEASE_ESCROW: 'RELEASE_ESCROW',
    RELEASE_ESCROW_SUCCESS: 'RELEASE_ESCROW_SUCCESS',
    RELEASE_ESCROW_FAIL: 'RELEASE_ESCROW_FAIL',

    PAYOUT_ESCROW: 'PAYOUT_ESCROW',
    PAYOUT_ESCROW_SUCCESS: 'PAYOUT_ESCROW_SUCCESS',
    PAYOUT_ESCROW_FAIL: 'PAYOUT_ESCROW_FAIL',

    PAYOUT_ESCROW_ROUND: 'PAYOUT_ESCROW_ROUND',
    PAYOUT_ESCROW_ROUND_SUCCESS: 'PAYOUT_ESCROW_ROUND_SUCCESS',
    PAYOUT_ESCROW_ROUND_FAIL: 'PAYOUT_ESCROW_ROUND_FAIL',

    UPDATE_AUTO_RELOAD: 'UPDATE_AUTO_RELOAD',
    UPDATE_AUTO_RELOAD_SUCCESS: 'UPDATE_AUTO_RELOAD_SUCCESS',
    UPDATE_AUTO_RELOAD_FAIL: 'UPDATE_AUTO_RELOAD_FAIL',

    GET_WALLET_TRANSACTIONS: 'GET_WALLET_TRANSACTIONS',
    GET_WALLET_TRANSACTIONS_SUCCESS: 'GET_WALLET_TRANSACTIONS_SUCCESS',
    GET_WALLET_TRANSACTIONS_FAIL: 'GET_WALLET_TRANSACTIONS_FAIL',

    GET_WALLET_FUND_OPTIONS: 'GET_WALLET_FUND_OPTIONS',
    GET_WALLET_FUND_OPTIONS_SUCCESS: 'GET_WALLET_FUND_OPTIONS_SUCCESS',
    GET_WALLET_FUND_OPTIONS_FAIL: 'GET_WALLET_FUND_OPTIONS_FAIL',

    VERIFY_WALLET_FUND: 'VERIFY_WALLET_FUND',
    CAMPAIGN_WALLET_DEPOSIT_COMPLETED: 'CAMPAIGN_WALLET_DEPOSIT_COMPLETED',

    ADMIN_CREDIT_CAMPAIGN_WALLET: 'ADMIN_CREDIT_CAMPAIGN_WALLET',
    ADMIN_CREDIT_CAMPAIGN_WALLET_SUCCESS: 'ADMIN_CREDIT_CAMPAIGN_WALLET_SUCCESS',
    ADMIN_CREDIT_CAMPAIGN_WALLET_FAIL: 'ADMIN_CREDIT_CAMPAIGN_WALLET_FAIL',
    CLEAR_ADMIN_CAMPAIGN_WALLET_CREDIT: 'CLEAR_ADMIN_CAMPAIGN_WALLET_CREDIT',

    GET_CAMPAIGN_REPORT: 'GET_CAMPAIGN_REPORT',
    GET_CAMPAIGN_REPORT_SUCCESS: 'GET_CAMPAIGN_REPORT_SUCCESS',
    GET_CAMPAIGN_REPORT_FAIL: 'GET_CAMPAIGN_REPORT_FAIL',

    GET_CAMPAIGN_REPORT_CONTENT: 'GET_CAMPAIGN_REPORT_CONTENT',
    GET_CAMPAIGN_REPORT_CONTENT_SUCCESS: 'GET_CAMPAIGN_REPORT_CONTENT_SUCCESS',
    GET_CAMPAIGN_REPORT_CONTENT_FAIL: 'GET_CAMPAIGN_REPORT_CONTENT_FAIL',

    GET_CAMPAIGN_REPORT_CREATORS: 'GET_CAMPAIGN_REPORT_CREATORS',
    GET_CAMPAIGN_REPORT_CREATORS_SUCCESS: 'GET_CAMPAIGN_REPORT_CREATORS_SUCCESS',
    GET_CAMPAIGN_REPORT_CREATORS_FAIL: 'GET_CAMPAIGN_REPORT_CREATORS_FAIL',

    GET_CAMPAIGN_REPORT_SYNC_STATUS: 'GET_CAMPAIGN_REPORT_SYNC_STATUS',
    GET_CAMPAIGN_REPORT_SYNC_STATUS_SUCCESS: 'GET_CAMPAIGN_REPORT_SYNC_STATUS_SUCCESS',
    GET_CAMPAIGN_REPORT_SYNC_STATUS_FAIL: 'GET_CAMPAIGN_REPORT_SYNC_STATUS_FAIL',

    SYNC_CAMPAIGN_REPORT: 'SYNC_CAMPAIGN_REPORT',
    SYNC_CAMPAIGN_REPORT_SUCCESS: 'SYNC_CAMPAIGN_REPORT_SUCCESS',
    SYNC_CAMPAIGN_REPORT_FAIL: 'SYNC_CAMPAIGN_REPORT_FAIL',

    BOOST_CAMPAIGN_REPORT: 'BOOST_CAMPAIGN_REPORT',
    BOOST_CAMPAIGN_REPORT_SUCCESS: 'BOOST_CAMPAIGN_REPORT_SUCCESS',
    BOOST_CAMPAIGN_REPORT_FAIL: 'BOOST_CAMPAIGN_REPORT_FAIL',

    CLEAR_CAMPAIGN_REPORT: 'CLEAR_CAMPAIGN_REPORT',

    POST_INFLUENCER_GUEST_OAUTH_LINK: 'POST_INFLUENCER_GUEST_OAUTH_LINK',
    POST_INFLUENCER_GUEST_OAUTH_LINK_SUCCESS: 'POST_INFLUENCER_GUEST_OAUTH_LINK_SUCCESS',
    POST_INFLUENCER_GUEST_OAUTH_LINK_FAIL: 'POST_INFLUENCER_GUEST_OAUTH_LINK_FAIL',

    POST_INFLUENCER_OAUTH_CONNECT: 'POST_INFLUENCER_OAUTH_CONNECT',
    POST_INFLUENCER_OAUTH_CONNECT_SUCCESS: 'POST_INFLUENCER_OAUTH_CONNECT_SUCCESS',
    POST_INFLUENCER_OAUTH_CONNECT_FAIL: 'POST_INFLUENCER_OAUTH_CONNECT_FAIL',

    POST_INFLUENCER_FROM_CONNECTED_INSTAGRAM: 'POST_INFLUENCER_FROM_CONNECTED_INSTAGRAM',
    POST_INFLUENCER_FROM_CONNECTED_INSTAGRAM_SUCCESS: 'POST_INFLUENCER_FROM_CONNECTED_INSTAGRAM_SUCCESS',
    POST_INFLUENCER_FROM_CONNECTED_INSTAGRAM_FAIL: 'POST_INFLUENCER_FROM_CONNECTED_INSTAGRAM_FAIL',

    CLAIM_PENDING_INFLUENCER: 'CLAIM_PENDING_INFLUENCER',
    CLAIM_PENDING_INFLUENCER_SUCCESS: 'CLAIM_PENDING_INFLUENCER_SUCCESS',
    CLAIM_PENDING_INFLUENCER_FAIL: 'CLAIM_PENDING_INFLUENCER_FAIL',

    REQUEST_DELIVERY_EXTENSION: 'REQUEST_DELIVERY_EXTENSION',
    REQUEST_DELIVERY_EXTENSION_SUCCESS: 'REQUEST_DELIVERY_EXTENSION_SUCCESS',
    REQUEST_DELIVERY_EXTENSION_FAIL: 'REQUEST_DELIVERY_EXTENSION_FAIL',

    APPROVE_DELIVERY_EXTENSION: 'APPROVE_DELIVERY_EXTENSION',
    APPROVE_DELIVERY_EXTENSION_SUCCESS: 'APPROVE_DELIVERY_EXTENSION_SUCCESS',
    APPROVE_DELIVERY_EXTENSION_FAIL: 'APPROVE_DELIVERY_EXTENSION_FAIL',

    REJECT_DELIVERY_EXTENSION: 'REJECT_DELIVERY_EXTENSION',
    REJECT_DELIVERY_EXTENSION_SUCCESS: 'REJECT_DELIVERY_EXTENSION_SUCCESS',
    REJECT_DELIVERY_EXTENSION_FAIL: 'REJECT_DELIVERY_EXTENSION_FAIL',

    OPEN_LIVE_LINK_WINDOW: 'OPEN_LIVE_LINK_WINDOW',
    OPEN_LIVE_LINK_WINDOW_SUCCESS: 'OPEN_LIVE_LINK_WINDOW_SUCCESS',
    OPEN_LIVE_LINK_WINDOW_FAIL: 'OPEN_LIVE_LINK_WINDOW_FAIL',
};

type GroupType = 'active_jobs' | 'requests' | 'invitations';

export interface ISocialLinks {
    instagram?: string;
    tiktok?: string;
    youtube?: string;
    facebook?: string;
    twitter?: string;
    x?: string;
    linkedin?: string;
    thspian?: string;
}

export interface IBrandSocialProfile {
    _id?: string;
    platform: string;
    url: string;
    account_label?: string;
    username?: string;
    display_name?: string;
    bio?: string;
    platform_verified?: boolean;
    profile_image_url?: string;
    follower_count?: number;
    following_count?: number;
    engagement_rate?: number;
    engagement_score?: number;
    avg_likes_per_post?: number;
    avg_comments_per_post?: number;
    avg_views?: number;
    post_count?: number;
    monthly_reach?: number;
    stats_last_synced_at?: string;
    linked?: boolean;
    linked_at?: string;
    sort_order?: number;
    is_visible?: boolean;
}

export interface IBrandSocialLoginPayload {
    brand_id: string;
    code: string;
    provider: string;
}

export interface IBrandManualSocialLinkBody {
    platform: string;
    url: string;
    username?: string;
    follower_count?: number;
    engagement_rate?: number;
    linked?: boolean;
}

export interface ICreateBrandSocialLinkPayload {
    brandId: string;
    payload: IBrandManualSocialLinkBody;
}

export interface IUpdateBrandSocialLinkPayload {
    brandId: string;
    linkId: string;
    payload: Partial<Omit<IBrandManualSocialLinkBody, 'platform'>>;
}

export type TIndustry =
    | 'Adult Entertainment'
    | 'Agriculture & Farming'
    | 'Animals & Wildlife'
    | 'Anime & Otaku Culture'
    | 'Art & Design'
    | 'Astrology & Horoscope'
    | 'Automotive'
    | 'Beauty & Personal Care'
    | 'Blogging & Vlogging'
    | 'Books & Publishing'
    | 'Business & Startups'
    | 'Cannabis & CBD'
    | 'Career & Job Search'
    | 'Celebrities & Gossip'
    | 'Charity & Activism'
    | 'Comics & Graphic Novels'
    | 'Conspiracy Theories'
    | 'Cooking & Recipes'
    | 'Crafts & DIY'
    | 'Cryptocurrency'
    | 'Culture & Society'
    | 'Dance'
    | 'Dating & Relationships'
    | 'Design & UX'
    | 'Education'
    | 'E-commerce'
    | 'Entertainment & Media'
    | 'Entrepreneurship'
    | 'Esports'
    | 'Events & Experiences'
    | 'Family & Parenting'
    | 'Fashion'
    | 'Finance & Banking'
    | 'Fitness & Sports'
    | 'Food & Beverage'
    | 'Gaming'
    | 'Gambling'
    | 'Gardening'
    | 'Health & Wellness'
    | 'History & Facts'
    | 'Hobbies & Interests'
    | 'Home & Living'
    | 'Humor & Memes'
    | 'Interior Design'
    | 'K-pop & J-pop'
    | 'Legal & Law'
    | 'Lifestyle'
    | 'Luxury Goods'
    | 'Marketing & Advertising'
    | "Men's Interests"
    | 'Mental Health'
    | 'Movies & TV'
    | 'Music & Nightlife'
    | 'Mythology & Folklore'
    | 'Nature & Outdoors'
    | 'News & Commentary'
    | 'Non-profit & Social Impact'
    | 'Parenting & Family'
    | 'Paranormal & Supernatural'
    | 'Pet Care'
    | 'Photography & Videography'
    | 'Politics & Commentary'
    | 'Professional Services'
    | 'Real Estate'
    | 'Religion & Faith'
    | 'Reviews & Unboxings'
    | 'Science & Innovation'
    | 'Self-Improvement'
    | 'Sexual Wellness'
    | 'Spirituality & Mindfulness'
    | 'Sustainability & Eco-Friendly'
    | 'Technology & Electronics'
    | 'Toys & Collectibles'
    | 'Travel & Hospitality'
    | 'True Crime'
    | 'Veganism & Plant-based Living'
    | 'Virtual Reality & Metaverse'
    | 'Weddings & Relationships'
    | 'Wellness Retreats & Healing'
    | "Women's Interests";

export interface IBrand {
    _id?: string;
    name: string;
    industry?: TIndustry;
    logo?: string;
    feature_image?: string;
    website?: string;
    description?: string;
    location?: ILocation;
    social_links?: ISocialLinks;
    /** Virtual populate of BrandSocialLink docs (available on GET /:id). */
    social_profiles?: any[];
    /** Linked Company document ObjectId. */
    company?: string;
    verified?: boolean;
    /** When true, this brand is the user's default for the brand dashboard (see Brand schema). */
    is_default?: boolean;
    deleted?: boolean;
    created_by: string;
    createdAt?: string;
    updatedAt?: string;
}

export interface ICreateBrand
    extends Pick<
        IBrand,
        | 'name'
        | 'industry'
        | 'logo'
        | 'feature_image'
        | 'website'
        | 'description'
        | 'social_links'
        | 'is_default'
        | 'location'
    > {
    rawLogo?: File[];
    rawFeatureImage?: File[];
    social_profiles?: IBrandSocialProfile[];
}

export interface IGetBrands {
    searchTerm?: string;
}

/** The pagination below will work per group */
export interface IGetBuzzBridgeProfile {
    group_type?: GroupType; // 'active_jobs', 'requests', 'invitations', or undefined for all
    page?: number;
    limit?: number;
    skipRefresh?: boolean;
}

export interface IGetPublicInfluencerProfilePayload {
    userName: string;
}

export interface ISaveManualInstagramLinkPayload {
    /** Defaults to instagram for backward compatibility */
    platform?: 'instagram' | 'tiktok' | 'youtube';
    influencerId?: string;
    uploadHeadshotOnly?: boolean;
    data: {
        userName: string;
        followers: string;
        lastPostViews: string;
        lastPostComments: string;
        lastPostLikes: string;
        headshotPreview?: string;
        headshotFile?: File;
    };
}

export interface ISearchBrand {
    searchTerm?: string;
}

export interface IGetHostDashboard {
    brandId?: string;
}

export interface IHostDashboardAggregates {
    active_campaigns_count: number;
    campaigns_starting_within_48h_count: number;
    distinct_brands_in_scope_count: number;
    pending_join_requests_count: number;
    pending_join_avatars: { name: string; profile_picture: string }[];
    pending_content_review_count: number;
    pending_content_avatars: { name: string; profile_picture: string }[];
    active_spend_total: number;
    active_spend_percent: number;
}

export type HostDashboardInsightStatus = 'pending_data' | 'ready' | string;

export interface IHostDashboardInsight {
    id: string;
    status: HostDashboardInsightStatus;
    title: string;
    body: string;
    metrics: Record<string, unknown> | null;
}

export interface IHostDashboardRecentCampaign {
    _id: string;
    title: string;
    brand: string;
    status: 'draft' | 'published' | 'paused' | 'completed' | string;
    feature_image?: string;
    products?: string[];
    primary_product?: string | null;
    total_budget: number;
    available_budget: number;
    start_date?: string | null;
    end_date?: string | null;
    participants_count_field?: number | null;
    total_participants_count?: number | null;
    participants_total: number;
    participants_active: number;
    completion_percent: number;
    is_active: boolean;
    unread_messages_total?: number;
}

export interface IHostDashboardData {
    scope: { brand_id: string | null };
    brands: IBrand[];
    default_brand: IBrand | null;
    active_brand: IBrand | null;
    insights?: IHostDashboardInsight[];
    aggregates: IHostDashboardAggregates;
    recent_campaigns: IHostDashboardRecentCampaign[];
}

export interface IJoinProgramPayload {}

// ── Campaign types ──────────────────────────────────────────────────────

export type CampaignReward = 'paid' | 'gifted' | 'both';
/** Dynamic id from GlobalConfiguration.influencer_tiers. */
export type InfluencerTier = string;
export type CampaignPlatform = 'facebook' | 'instagram' | 'tiktok' | 'thspian' | 'x' | 'twitter' | 'reddit' | 'youtube';
export type ParticipantStatus = 'pending' | 'approved' | 'rejected' | 'in_progress' | 'completed';

export interface ICampaignAsset {
    url: string;
    description?: string;
    requirements?: string[];
}

export interface ICampaignAssetWithFile extends ICampaignAsset {
    file?: File;
}

export type DeliverableType =
    | 'instagram_post'
    | 'instagram_reel'
    | 'instagram_story'
    | 'tiktok_video'
    | 'tiktok_short'
    | 'youtube_short'
    | 'youtube_video'
    | 'twitter_post'
    | 'facebook_post'
    | 'ugc_video'
    | 'ugc_photo'
    | 'vertical'
    | 'horizontal';

export type DeliverablePlatform = 'instagram' | 'tiktok' | 'youtube' | 'twitter' | 'facebook' | 'x';

export type DeliverableDuration = 'n/a' | '0-15s' | '15-30s' | '30s-1min' | '1min-3min' | '3min-5min' | '5min+';

export interface IDeliverableMultipleUploads {
    enabled: boolean;
    /** How many separate uploads required (min 2). */
    count: number;
    /** Required label per slot — length must equal count. */
    labels: string[];
}

export interface IDeliverable {
    type: DeliverableType;
    platform?: DeliverablePlatform;
    duration_range: DeliverableDuration;
    count: number;
    notes?: string;
    multiple_uploads?: IDeliverableMultipleUploads;
}

export interface IDeliverableRound {
    _id?: string;
    round_number: number;
    label?: string;
    delivery_date: string;
    deliverables: IDeliverable[];
}

export type CampaignCommissionTargetType = 'contest' | 'external';

export interface ICampaignCommissionExternal {
    product_name?: string;
    product_description?: string;
    product_url?: string;
    product_image?: string;
    store_name?: string;
    sku?: string;
    fulfillment?: 'physical' | 'digital' | string;
}

export interface ICampaignCommissionConfig {
    target_type: CampaignCommissionTargetType;
    rate: number;
    requires_approval?: boolean;
    contest?: string;
    /** Linked CommissionProgram id (set by API after sync). */
    program?: string | { _id?: string };
    display_pool_cents?: number;
    external?: ICampaignCommissionExternal;
}

export interface ICampaignCommissionEstimate {
    target_type?: CampaignCommissionTargetType;
    shrinks_with_fill?: boolean;
    commission_rate?: number;
    pool_cents?: number;
    remaining_pool_cents?: number;
    total_slots?: number;
    filled_slots?: number;
    remaining_slots?: number;
    possible_earning_cents?: number;
    possible_earning?: number;
    note?: string;
}

export interface ICampaignCommissionContestSummary {
    _id?: string;
    title?: string;
    slug?: string;
    date_start?: string;
    expiration_date?: string;
    feature_image?: string;
    thumbnail?: string;
    status?: string;
}

export interface IParticipantCommissionGrant {
    code?: string;
    share_url?: string;
    enrollment_id?: string;
}

export interface ICreateCampaignPayload {
    brand: string;
    title: string;
    description?: string;
    objectives?: string[];
    requirements?: string[];
    ideas?: string[];
    deliverables?: IDeliverable[];
    recurrent_deliverables?: boolean;
    deliverable_rounds?: IDeliverableRound[];
    base_payment_per_creator_cents?: number;
    parent_campaign?: string | null;
    reward?: CampaignReward;
    products?: string[];
    influencer_tier?: InfluencerTier;
    platforms?: CampaignPlatform[];
    production_company?: string;
    feature_image?: string;
    assets?: ICampaignAsset[];
    total_budget: number;
    available_budget: number;
    /** Requested creator seats (also sent as total_participants_count on create). */
    participants_count?: number;
    /** Seat cap / requested creators — preferred over participants_count for capacity. */
    total_participants_count?: number;
    start_date?: string;
    end_date?: string;
    publish_date?: string;
    delivery_date?: string;
    location?: ILocation;
    /** Accept applications from creators globally (location optional for display) */
    world_wide?: boolean;
    physical_product?: boolean;
    /** Brand receives exclusive commercial usage of content (typically 12 months). */
    exclusive_rights?: boolean;
    /**
     * 'standard' (default), 'direct_hire' — skips live URL, 'sync_upload' — all creators post at same time,
     * 'commission' — influencers promote contest/external product for % of attributed revenue
     */
    campaign_type?: 'standard' | 'direct_hire' | 'sync_upload' | 'commission';
    /** Required when campaign_type === 'sync_upload' — future date when all creators go live */
    sync_publish_date?: string;
    /** Brand uploads source footage; creators edit/clip it */
    is_clipping?: boolean;
    /** Public link to source video (Google Drive, Dropbox, etc.) */
    clipping_asset_url?: string;
    /**
     * Premium campaigns require OAuth-connected accounts + selected plan
     * entitlements (instagram_automation / auto_upload).
     */
    premium?: boolean;
    premium_requirements?: CampaignPremiumRequirement[];
    /** UGC campaign content category — matches backend CategorySchema.main */
    category?: string;
    /** UGC campaign content sub-category — matches backend CategorySchema.sub */
    sub_category?: string;
    /** Primary “what you’ll do” note for commission (and reusable elsewhere). */
    influencer_readme?: string;
    /** Commission program config — required when campaign_type === 'commission'. */
    commission?: ICampaignCommissionConfig;
    /** App / web install tracking config */
    app_install?: {
        enabled: boolean;
        kind?: 'app_install' | 'web_visit';
        app_display_name?: string;
        app_icon_url?: string;
        android_package?: string;
        android_store_url?: string;
        ios_store_url?: string;
        web_fallback_url?: string;
        auto_reload_enabled?: boolean;
        payment_method_id?: string;
        original_budget_cents?: number;
        cpa_cents?: number;
    };
    /** Raw file for uploading feature_image — stripped before API call */
    rawFeatureImage?: File;
    /** Raw app icon for app_install.app_icon_url — stripped before API call */
    rawAppIconFile?: File;
    /** Raw asset entries with files — stripped before API call */
    rawAssets?: ICampaignAssetWithFile[];
    /** Raw sample video files — uploaded after campaign creation via signed URL — stripped before API call */
    rawSampleVideos?: File[];
}

export interface ICampaignBrandPopulated {
    _id: string;
    name: string;
    profile_picture?: string;
    logo?: string;
    feature_image?: string;
    description?: string;
    industry?: string;
    website?: string;
    socials?: Record<string, string>;
    /** Cached average from BrandReview aggregates */
    rating?: number | null;
    number_of_reviews?: number;
}

export interface ICampaignParticipantTag {
    main: string;
    sub?: string;
}

export interface ICampaignParticipantInitiator {
    _id: string;
    firstName?: string;
    lastName?: string;
    userName?: string;
    email?: string;
}

export interface ICampaignParticipantDetail {
    _id: string;
    name: string;
    handle: string;
    avatar: string;
    status: ParticipantStatus;
    followers: number;
    engagementRate: number;
    tags: (string | ICampaignParticipantTag)[];
    pitch?: string;
    contentStatus?: string | null;
    previewVideo?: string | null;
    requestedAt?: string;
    accepted_by_creator?: boolean;
    accepted_by_influencer?: boolean;
    influencer_id?: string;
    /** Whether the current brand user favourited this applicant for this campaign. */
    is_favorited?: boolean;
    initiator?: ICampaignParticipantInitiator;
    /** Host/creator thread unread — from GET /campaigns/:id (host) or /me/profile buckets */
    unread_message_count?: number;
    /** Commission promo code after approve (commission campaigns). */
    commission_code?: string;
    commission?: IParticipantCommissionGrant;
}

/** Compact pending invite on public campaign detail for the signed-in creator. */
export interface IViewerPendingInvite {
    _id: string;
    status: ParticipantStatus;
    accepted_by_creator?: boolean;
    accepted_by_influencer?: boolean;
    requestedAt?: string;
}

export interface ICampaignSampleVideo {
    _id: string;
    url: string;
    title?: string;
    description?: string;
}

export interface ICampaign extends Omit<ICreateCampaignPayload, 'brand'> {
    _id: string;
    /** String (create/list) or populated object (detail) */
    brand: string | ICampaignBrandPopulated;
    status?: string;
    approved?: boolean;
    funded?: boolean;
    deleted?: boolean;
    verified?: boolean;
    slug?: string;
    short_url?: string;
    created_by?: string;
    createdAt?: string;
    updatedAt?: string;
    /** Active participants — approved / in_progress / completed */
    participants?: ICampaignParticipantDetail[];
    /** Pending join requests awaiting review (creator applied) */
    pending_requests?: ICampaignParticipantDetail[];
    /** Pending invites awaiting creator accept/decline (host invited) */
    pending_invites?: ICampaignParticipantDetail[];
    /** Public detail (host viewer) — pending application count */
    pending_requests_count?: number;
    /** Public detail (host viewer) — pending invite count */
    pending_invites_count?: number;
    /** Public detail — signed-in creator's pending invite for Accept/Decline CTAs */
    viewer_pending_invite?: IViewerPendingInvite | null;
    possible_earning?: string;
    possible_earning_cents?: number;
    sample_videos?: ICampaignSampleVideo[];
    /** Commission campaigns — structured estimate from server. */
    commission_estimate?: ICampaignCommissionEstimate;
    /** Linked contest summary when commission.target_type === 'contest'. */
    commission_contest?: ICampaignCommissionContestSummary | null;
    /** Product merchandising when commission.target_type === 'external'. */
    commission_external?: ICampaignCommissionExternal | null;
    /** Public detail — server-computed urgency badge (no slot counts on public API). */
    filling_fast?: boolean;
    /** Public detail — all creator slots filled. */
    at_capacity?: boolean;
    /** Host detail — slots filled vs total (not returned on public campaign detail). */
    filled_positions?: number;
    positions_available?: number;
    active_participants?: number;
    is_at_capacity?: boolean;
    participation_gate?: ICampaignParticipationGate;
    /** Public/detail — viewer eligibility for premium apply gates */
    premium_access?: ICampaignPremiumAccess;
    /** Host/creator fee previews — from GET /campaigns/:id or /public/:id */
    fee_breakdown?: ICampaignFeeBreakdown;
    /** Referral cash/points if a referred friend completes this campaign job */
    referral_earnings_if_friend_hired?: ICampaignReferralEarningsIfFriendHired;
    /** Host campaign detail — sum of roster + pending unread counts */
    unread_messages_total?: number;
    /** Host detail — funding pause (refund / empty CPA float). */
    funding_paused?: boolean;
    funding_pause_reason?: string | null;
    funding_paused_at?: string | null;
    funding_previous_status?: string | null;
    pause_reason_note?: string | null;
    /** App-install attribution config — returned on host campaign detail when app_install is enabled */
    app_install_attribution?: IAppInstallAttribution;
}

export interface IAppInstallAttribution {
    enabled: boolean;
    cpa_cents: number;
    cpa: number;
    click_ttl_hours: number;
    environment: string;
    app_token_prefix: string;
    app_token: string;
    float_cents: number;
    share_url_template: string;
    hybrid: boolean;
    note?: string;
}

export interface IGetCampaigns {
    created_by?: string;
    brand?: string;
    status?: string;
    funded?: boolean;
    page?: number;
    limit?: number;
    sort?: string;
    search?: string;
    fields?: string;
}

export interface IGetCampaignsResponse {
    status: string;
    totalCount: number;
    pageSize: number;
    currentPage: number;
    totalPages: number;
    results: number;
    data: { data: ICampaign[] };
}

export interface IManagedCampaignsListResult {
    campaigns: ICampaign[];
    currentPage: number;
    totalPages: number;
    totalCount: number;
}

export interface ISearchCampaigns {
    searchTerm: string;
    lastEvaluatedkey?: number;
}

export interface IUpdateCampaignPayload {
    campaignId: string;
    body: Partial<ICreateCampaignPayload>;
}

// ── Campaign Participant types ──────────────────────────────────────────

export interface IParticipant {
    _id: string;
    campaign: string;
    influencer: any;
    status: ParticipantStatus;
    accepted_by_creator?: boolean;
    accepted_by_influencer?: boolean;
    initiator?: string;
    approved_by?: string;
    approved_at?: string;
    rejected_by?: string;
    rejected_at?: string;
    created_by?: any;
    createdAt?: string;
    updatedAt?: string;
    /** Unique promo code after commission campaign approve. */
    commission_code?: string;
    /** Nested grant from approve response. */
    commission?: IParticipantCommissionGrant;
}

export interface IRequestToJoinCampaign {
    campaignId: string;
}

export interface IApproveJoinRequest {
    requestId: string;
    campaignId: string;
}

export interface IBulkApproveJoinRequests {
    campaignId: string;
    participantIds?: string[];
}

export interface IBulkRejectJoinRequests {
    campaignId: string;
    participantIds?: string[];
    reason?: string;
}

export interface IBulkRescindParticipants {
    campaignId: string;
    participantIds?: string[];
    reason?: string;
}

export interface IBulkRescindSkippedDetail {
    id: string;
    reason: string;
}

export interface IBulkRescindResult {
    rescinded: number;
    skipped: number;
    skipped_details: IBulkRescindSkippedDetail[];
    participants_count?: number;
}

export interface IRejectJoinRequest {
    requestId: string;
    campaignId: string;
    reason?: string;
}

export interface IGetCampaignPendingInvites {
    campaignId: string;
    page?: number;
    limit?: number;
    search?: string;
}

export interface ICampaignPendingInvitesPagination {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
    hasMore: boolean;
}

export interface IGetCampaignPendingInvitesSuccess {
    campaignId: string;
    invites: ICampaignParticipantDetail[];
    pagination: ICampaignPendingInvitesPagination;
}

export interface ICancelCampaignInvite {
    participantId: string;
    campaignId: string;
}

/** After approval: remove creator from roster (PATCH …/rescind-approval). */
export interface IRescindParticipantApproval {
    participantId: string;
    campaignId: string;
    reason?: string;
}

export interface IInviteInfluencer {
    campaign: string;
    influencer: string;
    initiator: string;
}

export interface InfluencerProfile {
    username: string;
    followers: number;
    engagementRate: number;
    avg_likes: number;
    avg_comments: number;
    verified: boolean;
    profile_link: string;
    profile_picture: string;
    audience_demographics: AudienceDemographics;
    pricing: Pricing;
}

export interface AudienceDemographics {
    topCountries: CountryStat[];
    ageGroups: AgeGroupStat[];
    genderDistribution: GenderDistribution;
}

export interface CountryStat {
    country: string; // ISO Alpha-2 code, e.g. "NG", "GH"
    value: number; // number of followers from the country
}

export interface AgeGroupStat {
    group: string; // age group label, e.g. "18-24"
    value: number; // number of followers in the age group
}

export interface GenderDistribution {
    male: number;
    female: number;
    other: number;
}

export interface Pricing {
    post: string[]; // Could be string or number, depending on pricing model
    story: string[];
    reel: string[];
    video: string[];
    bundle: string[];
    igtv: string[];
}

/** Min/max USD range per deliverable (sliders and rate card builder). */
export type PriceCardRate = [number, number];

export interface IPriceCard {
    post: PriceCardRate;
    story: PriceCardRate;
    reel: PriceCardRate;
    video: PriceCardRate;
    bundle: PriceCardRate;
    igtv: PriceCardRate;
    'live stream': PriceCardRate;
    'sponsored post': PriceCardRate;
    'product review': PriceCardRate;
    'brand mention': PriceCardRate;
    'event coverage': PriceCardRate;
}

export interface IPlatformStats {
    username?: string;
    followers?: number;
    linked?: boolean;
    engagementRate?: number;
    avg_likes?: number;
    avg_comments?: number;
    verified?: boolean;
    profile_link?: string;
    profile_picture?: string;
    audience_demographics?: AudienceDemographics;
    pricing?: IPriceCard;
}

export interface ICategory {
    main: string;
    sub?: string;
}

export interface IDocument {
    name: string;
    format: string;
    url: string;
}

export interface IShippingAddress {
    addressLine1: string;
    addressLine2: string;
    country: string;
    zipcode?: string;
}

export interface IUnAvailabelDates {
    from: string;
    to: string;
    reason: string;
}

export interface IInfluencerPastWork {
    _id?: string;
    profile?: string;
    title?: string;
    link?: string;
    description?: string;
    type?: string;
    role?: string[];
    year?: string;
    awards?: string[];
    position?: number;
}

/** Published portfolio item from GET /influencers/public/:userName */
export interface IInfluencerPublicProject {
    _id?: string;
    title?: string;
    project_type?: string;
    feature_image?: string;
    description?: string;
    project_gallery?: string[];
    status?: string;
    public_status?: string;
    visible?: boolean;
    category?: string;
    createdAt?: string;
    video_id?: string;
    hls?: string;
    thumbnail?: string;
    media_type?: string;
    processing_complete?: boolean;
    downloadable?: boolean;
    download_link?: string;
    resolutions?: Record<string, string>;
}

export interface IInfluencerCreatedByUser {
    _id?: string;
    userName?: string;
    firstName?: string;
    lastName?: string;
    profile_picture?: string;
    verified?: boolean;
}

export interface IInfluencer {
    _id?: string;
    languages_spoken?: string[];
    categories?: ICategory[];
    profile_picture?: string;
    name?: string;
    date_of_birth?: string;
    country?: string;
    nationality?: string;
    bio?: string;

    instagram?: IPlatformStats;
    tiktok?: IPlatformStats;
    youtube?: IPlatformStats;
    facebook?: IPlatformStats;
    twitter?: IPlatformStats;
    thspian?: IPlatformStats;

    totalReach?: number;
    avg_engagement_rate?: number;
    avg_view_count?: number;
    total_content_pieces?: number;
    conversion_rate?: number;
    influencer_score?: number;
    niche_score?: number;
    /** Brand fit % from Find Talent search when brand_id is sent (persisted server-side). */
    brand_match?: number;
    ratings?: number;
    number_of_reviews?: number;
    completed_campaigns?: number;
    /** Public profile: recent brand reviews of this creator */
    recent_reviews?: Array<{
        _id?: string;
        rating?: number;
        review_text?: string;
        createdAt?: string;
        brand?: { name?: string; profile_picture?: string };
        user?: { firstName?: string; lastName?: string; userName?: string; profile_picture?: string };
    }>;

    preferred_collab_types?: string[];
    available_for_events?: boolean;
    available_for_long_term_collabs?: boolean;
    availability?: boolean;
    contracted_brands?: string[]; // ObjectId strings

    preferred_payment_method?: string;
    payment_account_details?: Record<string, any>;

    media_kit_link?: string;
    portfolio?: string[];
    documents?: IDocument[];
    past_work?: IInfluencerPastWork[];
    /** Public profile portfolio (published projects) */
    projects?: IInfluencerPublicProject[];
    /** Account handle echoed from public API */
    userName?: string;
    social_thumbnail?: string;
    /** Image URLs for public profile gallery */
    gallery?: string[];
    /** When true, rate card is hidden on public profile */
    hide_rate_card?: boolean;
    past_collaborations?: string[]; // ObjectId strings

    location?: ILocation;
    shipping_address?: IShippingAddress;
    unavailable_dates?: IUnAvailabelDates;

    deleted?: boolean;
    verified_by_platform?: boolean;
    created_by: string | IInfluencerCreatedByUser; // ObjectId or populated user card

    createdAt?: Date;
    updatedAt?: Date;

    past_collaborations_details: any[];
    contracted_brands_details: any[];
    calculatedReach: number;
    totalPosts: number;
    calculatedEngagement: number;
    active_jobs: any[];
    requests: any[];
    invitations: any[];
    completed_jobs: any[];
    active_jobs_count: number;
    requests_count: number;
    invitations_count: number;
    completed_jobs_count: number;
    /** Creator profile — sum of visible bucket unread counts */
    unread_messages_total?: number;
    /** Whether the current logged-in user has saved/favourited this influencer */
    is_favorited?: boolean;
    /**
     * Public profile (viewer-specific): whether the signed-in brand/host may open a DM.
     * When false, prompt to create/fund an active campaign before messaging.
     */
    can_message?: boolean;

    approved: boolean;

    /** Dashboard aggregates from GET /influencers/me/profile (optional until API ships all fields) */
    monthly_target?: number | null;
    pending_applications_count?: number;
    approved_applications_count?: number;
    total_earned_cents?: number;
    monthly_earned_cents?: number;
    monthly_goal_progress_percent?: number | null;
}

export interface IBuzzBridgeProfileResponse {
    status: string;
    pageSize: number;
    currentPage: number;
    data: Data;
    totalCount: TotalCount;
    totalPages: TotalPages;
    hasNextPage: HasNextPage;
    hasPreviousPage: HasPreviousPage;
    nextPage: NextPage;
    previousPage: PreviousPage;
    results: Results;
}

export interface Data {
    influencer: IInfluencer;
}

export interface Category {
    main: string;
}

export interface Instagram {
    username: string;
    followers: number;
    engagementRate: number;
    avg_likes: number;
    avg_comments: number;
    verified: boolean;
    profile_link: string;
    profile_picture: string;
    audience_demographics: AudienceDemographics;
    pricing: Pricing;
}

export interface AudienceDemographics {
    topCountries: TopCountry[];
    ageGroups: AgeGroup[];
    genderDistribution: GenderDistribution;
}

export interface TopCountry {
    country: string;
    value: number;
}

export interface AgeGroup {
    group: string;
    value: number;
}

export interface GenderDistribution {
    male: number;
    female: number;
    other: number;
}

export interface Tiktok {
    username: string;
    followers: number;
    engagementRate: number;
    avg_likes: number;
    avg_comments: number;
    verified: boolean;
    audience_demographics: AudienceDemographics2;
    pricing: Pricing2;
}

export interface AudienceDemographics2 {
    topCountries: any[];
    ageGroups: any[];
}

export interface Pricing2 {
    video: number[];
    post: any[];
    story: any[];
    reel: any[];
    bundle: any[];
    igtv: any[];
}

export interface Youtube {
    username: string;
    followers: number;
    engagementRate: number;
    avg_likes: number;
    avg_comments: number;
    verified: boolean;
    audience_demographics: AudienceDemographics3;
    pricing: Pricing3;
}

export interface AudienceDemographics3 {
    topCountries: any[];
    ageGroups: any[];
}

export interface Pricing3 {
    video: number[];
    post: any[];
    story: any[];
    reel: any[];
    bundle: any[];
    igtv: any[];
}

export interface Location {
    type: string;
    coordinates: number[];
    address: string;
}

export interface TotalCount {
    active_jobs: number;
    requests: number;
    invitations: number;
}

export interface TotalPages {
    active_jobs: number;
    requests: number;
    invitations: number;
}

export interface HasNextPage {
    active_jobs: boolean;
    requests: boolean;
    invitations: boolean;
}

export interface HasPreviousPage {
    active_jobs: boolean;
    requests: boolean;
    invitations: boolean;
}

export interface NextPage {
    active_jobs: any;
    requests: any;
    invitations: any;
}

export interface PreviousPage {
    active_jobs: any;
    requests: any;
    invitations: any;
}

export interface Results {
    active_jobs: number;
    requests: number;
    invitations: number;
}

// ── Campaign Wallet types ───────────────────────────────────────────────

export type WalletTransactionType =
    | 'deposit'
    | 'auto_reload'
    | 'escrow_lock'
    | 'escrow_release'
    | 'escrow_refund'
    | 'payout';
export type WalletTransactionStatus = 'pending' | 'completed' | 'failed';
export type EscrowStatus = 'active' | 'released';

export interface IAutoReload {
    enabled: boolean;
    threshold_cents: number;
    reload_amount_cents: number;
    payment_method_id?: string;
}

export interface ICampaignWallet {
    _id: string;
    user: string;
    balance_cents: number;
    currency: string;
    auto_reload: IAutoReload;
    stripe_customer_id?: string;
    createdAt?: string;
    updatedAt?: string;
}

export interface IWalletTransaction {
    _id: string;
    type: WalletTransactionType;
    amount_cents: number;
    balance_after_cents: number;
    status: WalletTransactionStatus;
    description: string;
    payment_method_type?: string;
    stripe_payment_intent_id?: string;
    campaign?: { _id: string; title: string } | null;
    createdAt: string;
}

export interface IFundingActivity {
    month: string;
    label: string;
    total_cents: number;
    count: number;
}

export interface IWalletDashboard {
    available_funds_cents: number;
    locked_in_escrow_cents: number;
    spent_this_month_cents: number;
    monthly_percentage_change: number;
    recent_transactions: IWalletTransaction[];
    funding_activity: IFundingActivity[];
}

export interface IWalletFundExchangeRate {
    from: string;
    to: string;
    rate: number;
    description: string;
    as_of?: number;
    as_of_iso?: string;
}

export interface IWalletFundPresetLabels {
    wallet_credit_primary: string;
    wallet_credit_secondary: string;
    you_pay: string;
}

export interface IWalletFundPresetWalletCredit {
    currency: string;
    amount_usd: number;
    amount_cents: number;
    formatted: string;
}

export interface IWalletFundLocalEquivalent {
    currency: string;
    amount_major?: number;
    formatted: string;
    rate?: number;
    note?: string;
}

export interface IWalletFundPresetYouPay {
    currency: string;
    symbol?: string;
    amount_cents: number;
    formatted: string;
    /** Local FX of USD wallet credit (payment currency minor units) */
    wallet_credit_cents?: number;
    wallet_credit_formatted?: string;
    fees_cents?: number;
    fees_formatted?: string;
    customer_fees_cents?: number;
    tax_cents?: number;
    platform_fee_total_cents?: number;
    formula?: string;
}

export interface IWalletFundPresetConversion {
    wallet_credit_usd: number;
    wallet_credit_usd_formatted: string;
    rate_usd_to_local: number;
    local_currency: string;
    local_wallet_equivalent_major?: number;
    local_wallet_equivalent_formatted?: string;
    formula?: string;
    note?: string;
}

/** @deprecated Prefer you_pay */
export interface IWalletFundPresetPayment {
    currency: string;
    symbol?: string;
    net_wallet_credit_cents?: number;
    customer_charge_cents: number;
    customer_charge_formatted: string;
    customer_fees_cents?: number;
    tax_cents?: number;
    platform_fee_total_cents?: number;
}

export interface IWalletFundPresetFundRequest {
    amount: number;
    currency: string;
}

export interface IWalletFundPresetFees {
    amount_earned_cents?: number;
    final_amount_cents?: number;
    customer_fees_cents?: number;
    tax_cents?: number;
    platform_fee_breakdown?: Record<string, number>;
    itemized_breakdown?: Array<{
        type: string;
        description: string;
        amount_cents: number;
        rate?: number | null;
        charged_to?: string;
    }>;
}

export interface IWalletFundPreset {
    id: string;
    labels: IWalletFundPresetLabels;
    /** @deprecated Use labels.wallet_credit_secondary */
    label_usd?: string;
    wallet_credit: IWalletFundPresetWalletCredit;
    wallet_credit_local_equivalent?: IWalletFundLocalEquivalent;
    conversion?: IWalletFundPresetConversion;
    you_pay: IWalletFundPresetYouPay;
    /** @deprecated Prefer you_pay */
    payment?: IWalletFundPresetPayment;
    fund_request: IWalletFundPresetFundRequest;
    fees?: IWalletFundPresetFees;
    /** When true, wallet credit was reduced so Flutterwave charge stays under processor max. */
    capped_for_processor_limit?: boolean;
    requested_wallet_credit_usd?: number;
    processor_max_charge_major?: number;
    /** Admin-only test top-up (e.g. admin_test_funding). */
    purpose?: string;
    /** When true, no platform service charges apply to this preset. */
    fees_waived?: boolean;
}

export interface IWalletFundMinimumFund {
    id?: string;
    wallet_credit_usd_cents?: number;
    wallet_credit_usd?: number;
    wallet_credit_usd_formatted?: string;
    wallet_credit_payment_currency?: string;
    wallet_credit_payment_currency_upper?: string;
    /** Local FX of minimum USD wallet credit (payment currency minor units) */
    wallet_credit_payment_cents?: number;
    wallet_credit_payment_formatted?: string;
    minimum_you_pay_formatted?: string;
    labels?: IWalletFundPresetLabels;
    wallet_credit?: IWalletFundPresetWalletCredit;
    wallet_credit_local_equivalent?: IWalletFundLocalEquivalent;
    you_pay?: IWalletFundPresetYouPay;
    fund_request?: IWalletFundPresetFundRequest;
    conversion?: IWalletFundPresetConversion;
    payment?: IWalletFundPresetPayment;
    fees?: IWalletFundPresetFees;
}

export type WalletFundProvider = 'paystack' | 'stripe' | 'flutterwave';

export type StripePaymentRegion = 'us' | 'eu';

export interface IWalletPaymentRail {
    preferred_provider?: WalletFundProvider;
    use_paystack?: boolean;
    use_flutterwave?: boolean;
    use_stripe?: boolean;
    paystack_available?: boolean;
    flutterwave_available?: boolean;
    stripe_available?: boolean;
    is_africa?: boolean;
    is_europe?: boolean;
    payment_region?: 'africa' | 'eu' | 'us' | string;
    country_code?: string;
    /** What the buyer is charged in (kobo/cents). Prefer over payment_currency for checkout. */
    charge_currency?: string | null;
    paystack_currency?: string | null;
    flutterwave_currency?: string | null;
    payment_currency?: string;
    wallet_currency?: string;
    stripe_region?: StripePaymentRegion | null;
    processor_fee_profile?: string;
    /** Region-specific Stripe key — initialize Stripe.js with this, not a hardcoded US key. */
    stripe_publishable_key?: string | null;
    paystack_public_key?: string | null;
    flutterwave_public_key?: string | null;
    channels?: string[];
    category_supported?: boolean;
    fallback_note?: string | null;
}

export interface IWalletFundOptions {
    country_code: string;
    country_name: string;
    wallet_currency: string;
    payment_currency: string;
    payment_currency_upper?: string;
    defaulted_to_usd?: boolean;
    display_denomination?: string;
    exchange_rate: IWalletFundExchangeRate;
    minimum_fund: IWalletFundMinimumFund;
    presets: IWalletFundPreset[];
    /** Admin-only: fixed test top-up preset(s), e.g. $2.80 with fees waived. */
    admin_presets?: IWalletFundPreset[];
    admin_test_funding_usd_cents?: number;
    admin_preset_note?: string;
    preset_wallet_credits_usd?: number[];
    /** Actual USD credits after Flutterwave max capping (may be lower than catalog presets). */
    preset_wallet_credits_usd_quoted?: number[];
    processor_charge_limit?: {
        provider?: 'flutterwave' | string;
        currency?: string;
        max_charge_major?: number;
        source?: string;
    };
    payment_rail?: IWalletPaymentRail;
    instructions?: {
        fund_endpoint?: string;
        amount_field?: string;
        currency_field?: string;
        minimum_note?: string;
        processor_limit_note?: string;
        /** How custom amount field is interpreted — gross_payment (NG) or wallet_credit_usd (USD markets). */
        custom_amount_input_mode?: WalletPaymentInputMode;
    };
}

export type WalletPaymentInputMode = 'gross_payment' | 'wallet_credit_payment' | 'wallet_credit_usd';

export interface IFundWalletPayload {
    /** Net USD wallet credit in cents — required for preset/USD flows; optional for gross_payment (server may recompute). */
    wallet_credit_usd_cents?: number;
    /** Alias for wallet_credit_usd_cents when funding in USD. */
    amount?: number;
    /** Authoritative gross charge in payment-currency minor units (Paystack / Stripe after sales-calc). */
    payment_amount_cents?: number;
    payment_input_mode?: WalletPaymentInputMode;
    provider?: WalletFundProvider;
    callback_url?: string;
    callbackUrl?: string;
    currency?: string;
    payment_method_type?: 'card' | 'bank_wire' | 'crypto';
    save_card?: boolean;
    metadata?: string | Record<string, unknown>;
}

export interface IFundWalletPaystackResponse {
    provider: 'paystack' | 'flutterwave';
    reference?: string;
    tx_ref?: string;
    access_code?: string;
    authorization_url: string;
    saleId?: string;
    transactionId?: string;
    amount?: number;
    currency?: string;
    wallet_credit_usd_cents?: number;
    wallet_credit_usd?: number;
    wallet_credit_usd_formatted?: string;
    payment_rail?: IWalletPaymentRail;
}

export interface IFundWalletStripeResponse {
    provider?: 'stripe';
    clientSecret: string;
    paymentIntentId?: string;
    saleId?: string;
    wallet_credit_usd_cents?: number;
    wallet_credit_usd_formatted?: string;
    payment_rail?: IWalletPaymentRail;
}

export type IFundWalletResponse = IFundWalletPaystackResponse | IFundWalletStripeResponse;

export interface IVerifyWalletFundPayload {
    reference?: string;
    transaction_id?: string;
    tx_ref?: string;
    provider?: 'paystack' | 'flutterwave';
}

export interface IVerifyWalletFundResult {
    verified: boolean;
    paystack_status?: string;
    reference: string;
    wallet?: {
        balance_cents: number;
        currency: string;
        balance_usd?: number;
    };
    transaction?: {
        status: string;
        amount_cents?: number;
        paystack_reference?: string;
        payment_provider?: string;
    };
}

export interface ICampaignWalletDepositSocketPayload {
    wallet: {
        _id?: string;
        balance_cents: number;
        currency: string;
    };
    transaction: {
        _id?: string;
        status: string;
        amount_cents?: number;
        amount_usd?: number;
        balance_after_cents?: number;
        payment_provider?: string;
        paystack_reference?: string;
    };
}

export interface IEscrowPayload {
    campaign_id: string;
    amount_cents: number;
}

export interface IEscrow {
    _id: string;
    wallet: string;
    campaign: string;
    user: string;
    amount_cents: number;
    spent_cents: number;
    released_cents: number;
    status: EscrowStatus;
    currency: string;
    createdAt?: string;
    updatedAt?: string;
}

export interface IPayoutPayload {
    campaignId: string;
    amount_cents: number;
    participant_id?: string;
}

export interface IUpdateAutoReloadPayload {
    enabled?: boolean;
    threshold_cents?: number;
    reload_amount_cents?: number;
    payment_method_id?: string;
}

export interface IGetTransactionsPayload {
    page?: number;
    limit?: number;
    type?: WalletTransactionType;
    status?: WalletTransactionStatus;
}

export const ADMIN_WALLET_CREDIT_MAX_USD_CENTS = 100_000;
export const ADMIN_WALLET_CREDIT_MAX_USD = 1000;
export const ADMIN_WALLET_CREDIT_MIN_USD_CENTS = 1;

export interface IAdminCreditWalletRequest {
    user_id: string;
    amount_cents?: number;
    amount_usd?: number;
    reason?: string;
}

export interface IAdminCreditWalletUser {
    _id: string;
    email: string;
    firstName?: string;
    lastName?: string;
    userName?: string;
    role: string;
}

export interface IAdminCreditWalletResult {
    user: IAdminCreditWalletUser;
    wallet: {
        _id: string;
        balance_cents: number;
        currency: 'usd';
    };
    transaction: {
        _id: string;
        type: 'admin_credit';
        amount_cents: number;
        balance_after_cents: number;
        status: 'completed';
        description: string;
        metadata: {
            purpose: 'admin_credit';
            credited_by_user_id: string | null;
            reason: string | null;
        };
        createdAt: string;
    };
    credited_by: {
        _id: string;
        email: string;
    };
}
